// extracted by mini-css-extract-plugin
module.exports = {"modalWindow":"modalDashboardTable_modalWindow__8hDvL","title":"modalDashboardTable_title__21or4","btn":"modalDashboardTable_btn__1JY_y"};